import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // Импортируем хук

import { ReactComponent as WarehouseIcon } from 'assets/icons/sidebar/warehouse.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { GET, httpOk } from 'helpers/api';
import { formatMoney } from 'helpers/helpers';
import { Link } from 'react-router-dom';
import Pagination from 'components/Pagination';

function Dashboard() {
	const { t } = useTranslation() // Инициализируем функцию t

	const initFilterData = {
		page: 1,
		page_size: 20,
	}

	const [filterData, setFilterData] = useState(initFilterData)

	const [data, setData] = useState({
		attention: [],
		summary: {},
	})

	const handlePaginate = (args) => {
		setFilterData(prev => ({
			...prev,
			page: args.page + 1,
			page_size: args.page_size
		}));
	};

	const getData = useCallback(async () => {
		const [response, responseStats] = await Promise.all([
			GET('/inventory/raw-warehouse/dashboard/', filterData),
			GET('/inventory/raw-warehouse/items/', filterData),
		]);

		if (httpOk(response)) {
			setData({ ...response.data, ...responseStats.data });
		}
	}, [filterData]); // Пустой массив зависимостей значит, что функция создастся один раз

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<>
			<div>
				<div className="main-content-title">
					{t('warehouse_worker_dashboard')}
				</div>

				<div className="main-content-subtitle">
					{t('inventory_control_desc')}
				</div>
			</div>

			<div className="grid2 gap-16">
				<div className="card">
					<div className="d-between">
						<div>
							<div className="title">
								{t('warehouse_positions_count')}
							</div>
							<div className="value">
								{data?.summary?.total_items}
							</div>
						</div>

						<div className="icon primary">
							<WarehouseIcon />
						</div>
					</div>
				</div>

				<div className="card">
					<div className="d-between">
						<div>
							<div className="title">
								{t('critical_stock')}
							</div>
							<div className="value text-danger">
								{data?.summary?.critical_count}
							</div>
						</div>

						<div className="icon danger">
							<WarningIcon />
						</div>
					</div>
				</div>
			</div>

			{data?.attention?.length > 0 &&
				<div className="alert second alert-danger">
					<div className="alert-title">
						<WarningIcon />
						{t('attention_required_count', { count: data?.attention?.length })}
					</div>

					<div className="mb-16">
						{t('critical_level_warning')}
					</div>

					<div className="d-flex flex-column gap-8">
						{data.attention.map((item, index) => (
							<div className="card second" key={index}>
								<div className="d-between">
									<div>
										<div className="text-first">
											{item.raw_material_name}
										</div>
										<div className="text-fifth fz12">
											{t('balance')}: {formatMoney(item.available_quantity)} {item.unit_short_name} из {formatMoney(item.min_level)} {item.unit_short_name}
										</div>
									</div>

									<div className={`alert alert-${item.status}`}>
										{t(item.status)}
									</div>
								</div>
							</div>
						))
						}
					</div>

					<Link to="/warehouse-raw/warehouse">
						<button className="dark mt-16">
							{t('go_to_raw_warehouse')}
						</button>
					</Link>
				</div>
			}

			<div className="card">
				<div className="d-between mb-30">
					<div className="fz16 text-third">
						{t('all_raw_materials')}
					</div>

					<Link to="/warehouse-raw/warehouse">
						<button className="dark">
							{t('warehouse_management')}
						</button>
					</Link>
				</div>

				<table className="table">
					<thead>
						<tr>
							<th style={{ width: '20%' }}>{t('category')}</th>
							<th style={{ width: '30%' }}>{t('name')}</th>
							<th style={{ width: '10%' }}>{t('balance')}</th>
							<th style={{ width: '20%' }}>{t('min_balance')}</th>
							<th style={{ width: '20%' }}>{t('status')}</th>
						</tr>
					</thead>

					<tbody>
						{data?.results?.map((item, index) => (
							<tr key={index}>
								<td>{item.category?.name}</td>
								<td>{item.raw_material_name}</td>
								<td>{formatMoney(item.available_quantity)} {item.unit_short_name}</td>
								<td>{formatMoney(item.min_level)} {item.unit_short_name}</td>
								<td>
									<div className={`alert alert-${item.status} w-fit-content`}>
										{t(item.status)}
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>

				<Pagination
					paginate={handlePaginate}
					pagination={{
						total: data?.count || 0
					}}
				/>
			</div>

			{/* <div className="card">
				<div className="mb-30 fz16 text-third">
					{t('quick_actions')}
				</div>

				<div className="d-flex gap-16 w-100">
					<button className="dark second" onClick={() => setAcceptanceMaterialsModal(true)}>
						<WarehouseIcon />
						{t('raw_material_receipt')}
					</button>

					<button className="white second" onClick={() => setPurchaseRequestModal(true)}>
						<ReportDownIcon />
						{t('create_purchase_request')}
					</button>
				</div>
			</div> */}

			{/* <PurchaseRequest modal={purchaseRequestModal} setModal={setPurchaseRequestModal} />
			<AcceptanceMaterials modal={acceptanceMaterialsModal} setModal={setAcceptanceMaterialsModal} getData={getData} /> */}
		</>
	)
}

export default Dashboard